import { render } from "./Tires.vue?vue&type=template&id=67d69920"
import script from "./Tires.vue?vue&type=script&lang=js"
export * from "./Tires.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__